import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
//Mixin
import "./mixins/global.js";


Vue.config.productionTip = false

//VueCryptojs
import VueCryptojs from 'vue-cryptojs'
Vue.use(VueCryptojs)


new Vue({
  router,
  vuetify,  
  render: h => h(App)
}).$mount('#app')

